import type { components } from "../../api/schema";
import { Button, Inline, InlineError, Stack } from "../../ui";
import { RowConfirm } from "../shared/RowConfirm";

type ScenarioSetResponse = components["schemas"]["ScenarioSetResponse"];

export interface ScenarioSetRowActionHandlers {
  deleteError: string | null;
  deleteScenarioSetId: string | null;
  isDeletePending: boolean;
  onCancelDelete: () => void;
  onConfirmDelete: (scenarioSet: ScenarioSetResponse) => void;
  onOpenEdit: (scenarioSetId: string) => void;
  onStartDelete: (scenarioSet: ScenarioSetResponse) => void;
}

export interface ScenarioSetRowActionsProps {
  handlers: ScenarioSetRowActionHandlers;
  scenarioSet: ScenarioSetResponse;
}

export function ScenarioSetRowActions({
  handlers,
  scenarioSet,
}: ScenarioSetRowActionsProps) {
  const isConfirming = handlers.deleteScenarioSetId === scenarioSet.id;
  const confirm = (
    <RowConfirm
      confirmLabel="Confirm delete"
      isConfirming={isConfirming}
      isPending={isConfirming && handlers.isDeletePending}
      isTriggerDisabled={handlers.isDeletePending}
      onCancel={handlers.onCancelDelete}
      onConfirm={() => {
        handlers.onConfirmDelete(scenarioSet);
      }}
      onStart={() => {
        handlers.onStartDelete(scenarioSet);
      }}
      pendingLabel="Deleting..."
      sentence={`Delete ${scenarioSet.display_name}? This removes the scenario set from its agent.`}
      triggerLabel="Delete"
    />
  );
  if (isConfirming) {
    return (
      <Stack gap={2}>
        {confirm}
        {handlers.deleteError ? (
          <InlineError>{handlers.deleteError}</InlineError>
        ) : null}
      </Stack>
    );
  }
  return (
    <Inline>
      <Button
        size="sm"
        type="button"
        variant="secondary"
        onClick={() => {
          handlers.onOpenEdit(scenarioSet.id);
        }}
      >
        Edit
      </Button>
      {confirm}
    </Inline>
  );
}
